import { Minimize2 } from 'lucide-react';
import React from 'react';

type FloatingWindowProps = {
  children: React.ReactNode;
  position: { x: number; y: number };
  onClose: (id: string) => void;
  onMouseDown: (e: React.MouseEvent) => void;
  id: string;
  title: string;
  icon: any;
  isDragging: boolean;
};

export function FloatingWindow({
  children,
  position,
  onClose,
  onMouseDown,
  id,
  title,
  icon: Icon,
  isDragging
}: FloatingWindowProps) {
  return (
    <div
      className={`fixed bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden ${isDragging ? 'dragging' : ''}`}
      style={{
        left: position.x,
        top: position.y,
        width: '300px',
        height: '400px'
      }}
    >
      <div
        className="cursor-move bg-gray-50 p-2"
        onMouseDown={(e) => {
          e.preventDefault();
          onMouseDown(e);
        }}
      >
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Icon className="w-4 h-4" />
            <span className="text-sm font-medium">{title}</span>
          </div>
          <button
            onClick={() => onClose(id)}
            className="p-1 hover:bg-gray-200 rounded-md"
          >
            <Minimize2 className="w-4 h-4" />
          </button>
        </div>
      </div>
      <div className={'h-full overflow-auto pb-6'}>
        <div>{children}</div>
      </div>
    </div>
  );
}
